import CustomerAdd from './CustomerAdd';

export default CustomerAdd;
